import { DiscriminationOfSubjects } from './DiscriminationOfSubjects';
export default DiscriminationOfSubjects;
